import { cloneDeep } from 'lodash'

export function sortSchedules (schedules) {
  if (!schedules) return []
  let schedulesTemp = []
  schedules.map(item => {
    schedulesTemp.push({
        'nome': item.resourceName,
        'nomeMedico': item.doctorName,
        'crm': item.registrationCode,
        'id': item.resourceLid,
        'notice': item.notice
    })
  });
  return schedulesTemp.sort((a, b) => (a.nome > b.nome) ? 1 : -1)
}

export function sortSchedulesPatient (schedules) {
  if (!schedules) return []
  let schedulesTemp = []
  schedules.map(item => {
    schedulesTemp.push({
        'nome': item.resourceName,
        'nomeMedico': item.doctorName,
        'crm': item.registrationCode,
        'id': item.resourceLid,
        'noticePatient' : item.noticePatient
    })
  });
  return schedulesTemp.sort((a, b) => (a.nome > b.nome) ? 1 : -1)
}


export function buttonsSchedulesPatient (schedules) {
  if (!schedules) return []
  let titleHistory = false;

  schedules.map(datesHours => {
    if(showTitleHistory(datesHours.dataAtendimento) && !titleHistory){
        datesHours.titleHistory = true;
        titleHistory = true;
      } else {
          datesHours.titleHistory = false;
      }
    datesHours.agendas.map(schedule => {
      schedule.habilityButons = habilityButons(schedule.dataHoraAtendimento);
    });
    
  });
  return schedules
}

// Define habilityButons (data >= hoje) em cada agenda, sem mexer em titleHistory.
export function applyHabilityButons (schedules) {
  if (!schedules) return []
  schedules.forEach(datesHours => {
    (datesHours.agendas || []).forEach(schedule => {
      schedule.habilityButons = habilityButons(schedule.dataHoraAtendimento)
    })
  })
  return schedules
}

function habilityButons(date){
  if(!date){
    return false
  }
  const today = new Date().setHours(0, 0, 0, 0);
  const appointmentDate = parseData(date);
  return appointmentDate >= today;
}

function showTitleHistory(date){

  if(!date){
    return false
  }
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const appointmentDate =  parseData(date);
  if(appointmentDate < today){
    return true;
  }
  return false;
}

function parseData(dateString) {
  const partesData = dateString.split('/');
  const day = parseInt(partesData[0], 10);
  const month = parseInt(partesData[1], 10) - 1; // Meses são baseados em zero
  const year = parseInt(partesData[2], 10);
  return new Date(year, month, day, 0, 0, 0, 0);
}